"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asXLSX = void 0;
const tslib_1 = require("tslib");
const XLSX = require("xlsx/dist/xlsx.full.min.js");
function asXLSX(rawReport, exportedBy) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const wb = initializeWorkbook(XLSX.utils.book_new(), rawReport, exportedBy);
        for (const section of rawReport.sections) {
            const rows = [];
            for (const entry of section.data) {
                rows.push(entry);
            }
            const sheet = XLSX.utils.json_to_sheet(rows, { header: section.subtitles });
            XLSX.utils.book_append_sheet(wb, sheet, section.title);
        }
        return wb;
    });
}
exports.asXLSX = asXLSX;
function initializeWorkbook(wb, rawReport, exportedBy) {
    var _a;
    if (!wb.Props)
        wb.Props = {};
    wb.Props = {
        Title: (rawReport === null || rawReport === void 0 ? void 0 : rawReport.name) || (rawReport === null || rawReport === void 0 ? void 0 : rawReport.filename) || `Aetonix Report`,
        Subject: (_a = rawReport === null || rawReport === void 0 ? void 0 : rawReport.description) !== null && _a !== void 0 ? _a : '',
        Author: `${exportedBy === null || exportedBy === void 0 ? void 0 : exportedBy.fname} ${exportedBy === null || exportedBy === void 0 ? void 0 : exportedBy.lname}`,
        CreatedDate: new Date(),
    };
    return wb;
}
//# sourceMappingURL=index.js.map